module.exports = __webpack_public_path__ + "img/1665.ac6da3dc.gif";